//TODO bu sadece TR için oluşturuldu ve sadece faqs var. Eksikler tamamlanmalı ve diğer dilller için de bir çözüm bulunmalı.
const faq = [
  createItem({
    title: { tr: "Nasıl Hesap Oluştururum?", en: "How do I create an account?", de: "Wie erstelle ich ein Konto?" },
    location: "/help-center/faqs?cat=cat1&col=col1_1",
  }),
  createItem({
    title: {
      tr: "Şifremi Unuttum Ne Yapmalıyım?",
      en: "What Should I Do If I Forgot My Password?",
      de: "Was soll ich tun, wenn ich mein Passwort vergessen habe?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_2",
  }),
  createItem({
    title: {
      en: "What Are Organization Roles?",
      de: "Was sind Organisationsrollen?",
      tr: "Organizasyon Rolleri Nedir?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_3",
  }),
  createItem({
    title: {
      en: "What Happens If I Delete a Role Holder from the System?",
      de: "Was passiert, wenn ich einen Rolleninhaber aus dem System lösche?",
      tr: "Rol Sahibi Kullanıcıyı Sistemden Sildiğimizde Ne Olur?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_4",
    // keywords: ["yenile", "refresh"],
  }),

  createItem({
    title: {
      en: "How Can I Customize the Library?",
      de: "Wie kann ich die Bibliothek anpassen?",
      tr: "Kütüphaneyi Nasıl Özelleştirebilirim?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_5",
    // keywords: ["kütüphane"],
  }),
  createItem({
    title: {
      en: "What Is Organizational Hierarchy?",
      de: "Was ist die Organisationshierarchie?",
      tr: "Organizasyon Hiyerarşisi Nedir?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_6",
    // keywords: ["kredi"],
  }),
  createItem({
    title: {
      en: "What Is Personal Data Inventory?",
      de: "Was ist ein Inventar persönlicher Daten?",
      tr: "Kişisel Veri Envanteri Nedir?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_7",
  }),
  createItem({
    title: {
      en: "What Is the Difference Between Direct Collection and Other Methods?",
      de: "Was ist der Unterschied zwischen direkter Erhebung und anderen Methoden?",
      tr: "Doğrudan Toplama Yöntemi ile Diğer Kanallardan Toplama Yönteminin Farkı Nedir?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_9",
    // keywords: ["account", "user", "kullanıcı", "password"],
  }),
  createItem({
    title: {
      en: "How Does the System Support Me in Creating a Personal Data Inventory?",
      de: "Wie unterstützt mich das System bei der Erstellung eines Inventars persönlicher Daten?",
      tr: "Kişisel Veri Envanterini Oluştururken Sistem Bana Nasıl Destek Olur?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_10",
    // keywords: ["hata", "error", "başarısız", "409"],
  }),
  createItem({
    title: {
      en: "How Does the System Support Identifying and Monitoring Compliance Risks?",
      de: "Wie unterstützt das System bei der Identifizierung und Überwachung von Compliance-Risiken?",
      tr: "Uyumluluk Risklerini Tanımlamakta ve İzlemekte Sistem Bana Nasıl Destek Olur?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_11",
    // keywords: ["hata", "error", "başarısız", "403", "401"],
  }),
  createItem({
    title: {
      en: "Can I Manage Corporate Risks in the System?",
      de: "Kann ich Unternehmensrisiken im System verwalten?",
      tr: "Sistemde Kurumsal Risklerin Yönetimini Yapabilir mi?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_12",
    // keywords: ["hata", "error", "başarısız", "204", "404"],
  }),
  createItem({
    title: {
      en: "How Does the System Support Me in Creating Information Security Asset Groups?",
      de: "Wie unterstützt mich das System bei der Erstellung von Informationssicherheits-Vermögensgruppen?",
      tr: "Bilgi Güvenliği Varlık Gruplarını Oluştururken Sistem Bana Nasıl Destek Olur?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_13",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How Can I Match the Organization's Asset Groups with Asset Inventories?",
      de: "Wie kann ich die Vermögensgruppen der Organisation mit Inventaren abgleichen?",
      tr: "Organizasyonun Varlık Grupları ile Varlık Envanterlerini Nasıl Eşleştirebilirim?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_14",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How Does the System Support Me in Evaluating Compliance Measures and Creating Information Security Controls?",
      de: "Wie unterstützt mich das System bei der Bewertung von Compliance-Maßnahmen und der Erstellung von Informationssicherheitskontrollen?",
      tr: "Uyumluluk Tedbirlerini Değerlendirirken ve Bilgi Güvenliği Kontrollerini Oluştururken Sistem Bana Nasıl Destek Olur?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_15",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "Can We Manage Compliance Measures with Shared Action Plans Together?",
      de: "Können wir Compliance-Maßnahmen mit gemeinsamen Aktionsplänen gemeinsam verwalten?",
      tr: "Uyumluluk Tedbirlerinden Aksiyon Planı Ortak Olanları Bir Arada Yönetebilir Miyiz?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_16",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How Are Action Plans for Measures Periodically Reviewed in the System?",
      de: "Wie werden Maßnahmen-Aktionspläne im System regelmäßig überprüft?",
      tr: "Tedbirlerin Aksiyon Planlarının Periyodik Olarak Gözden Geçirilmesi Sistemde Nasıl Yapılır?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_17",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How to Reinclude a Measure Marked as Out of Scope?",
      de: "Wie kann eine als außerhalb des Geltungsbereichs markierte Maßnahme wieder eingeschlossen werden?",
      tr: "Kapsam Dışı Olarak İşaretlenen Tedbir Yeniden Kapsam Dahiline Nasıl Alınır?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_18",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "Does the System Support Version Control for Created Files?",
      de: "Unterstützt das System die Versionskontrolle für erstellte Dateien?",
      tr: "Sistemde Oluşturulan Dosyaların Versiyon Yönetimi Yapılmakta Mı?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_19",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "Can I Upload Files to the System?",
      de: "Kann ich Dateien in das System hochladen?",
      tr: "Sisteme Dosya Yükleyebiliyor Muyuz?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_20",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How Is File Access Management Done?",
      de: "Wie wird die Zugriffsverwaltung von Dateien durchgeführt?",
      tr: "Dosyaların Erişim Yönetimi Nasıl Yapılır?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_21",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How Are Files Periodically Reviewed in the System?",
      de: "Wie werden Dateien im System regelmäßig überprüft?",
      tr: "Dosyaların Periyodik Olarak Gözden Geçirilmesi Sistemde Nasıl Yapılır?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_22",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "How Does the System Support Preparing Legal Documents Required by Regulations?",
      de: "Wie unterstützt das System bei der Erstellung von rechtlichen Dokumenten, die von Vorschriften verlangt werden?",
      tr: "Mevzuatların Gerekli Gördüğü Hukuki Dokümanları Hazırlarken Sistem Bana Nasıl Destek Olur?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_23",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "What Reports Does the System Provide to Support Users During the Compliance Management Process?",
      de: "Welche Berichte stellt das System bereit, um Benutzer während des Compliance-Management-Prozesses zu unterstützen?",
      tr: "Uyumluluk Sürecinin Yönetimi Sırasında Sistem Ne Tip Raporlar ile Kullanıcıyı Desteklemekte?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_24",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "Can I Use the System in Other Languages?",
      de: "Kann ich das System in anderen Sprachen nutzen?",
      tr: "Sistemi Başka Dillerde Kullanabilir miyim?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_25",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "Can I Get Consulting Services Related to the Compliance Project?",
      de: "Kann ich Beratungsdienstleistungen im Zusammenhang mit dem Compliance-Projekt erhalten?",
      tr: "Uyumluluk Projesi ile İlgili Danışmanlık Alabilir miyim?",
    },
    location: "/help-center/faqs?cat=cat1&col=col1_26",
    // keywords: ["hata", "error", "başarısız", "500"],
  }),

  //ERRORS
  createItem({
    title: {
      en: "The Record You Are Trying to Save Already Exists",
      de: "Der Datensatz, den Sie speichern möchten, ist bereits vorhanden",
      tr: "Kaydedilmek İstenen Kayıt Zaten Mevcut",
    },
    location: "/help-center/faqs?cat=cat2&col=col2_1",
    keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "You Do Not Have Permission for This Action",
      de: "Sie haben keine Berechtigung für diese Aktion",
      tr: "Bu işlem için yetkiniz yok",
    },
    location: "/help-center/faqs?cat=cat2&col=col2_2",
    keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "I Can't Make Updates in the Inventory",
      de: "Ich kann im Inventar keine Änderungen vornehmen",
      tr: "Envanterde Güncelleme Yapamıyorum",
    },
    location: "/help-center/faqs?cat=cat2&col=col2_3",
    keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "An Unexpected Error Occurred in the System",
      de: "Ein unerwarteter Fehler ist im System aufgetreten",
      tr: "Sistemde beklenmedik bir hata oluştu",
    },
    location: "/help-center/faqs?cat=cat2&col=col2_4",
    keywords: ["hata", "error", "başarısız", "500"],
  }),
  createItem({
    title: {
      en: "I Cannot Perform the Deletion Operation",
      de: "Ich kann den Löschvorgang nicht durchführen",
      tr: "Silme İşlemini Gerçekleştiremiyorum",
    },
    location: "/help-center/faqs?cat=cat2&col=col2_5",
    keywords: ["hata", "error", "başarısız", "500"],
  }),

  //Definitions

  createItem({
    title: {
      en: "Definition: What is Personal Data?",
      de: "Definition: Was sind personenbezogene Daten?",
      tr: "Tanım: Kişisel Veri Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_1",
  }),
  createItem({
    title: {
      en: "Definition: What is Sensitive Personal Data?",
      de: "Definition: Was sind sensible personenbezogene Daten?",
      tr: "Tanım: Özel Nitelikli Kişisel Veri Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_2",
    keywords: ["hassas", "din", "cinsel", "sağlık", "ceza", "kılık", "kıyafet", "etnik", "siyasi"],
  }),
  createItem({
    title: {
      en: "Definition: What is the Processing of Personal Data?",
      de: "Definition: Was ist die Verarbeitung personenbezogener Daten?",
      tr: "Tanım: Kişisel Verilerin İşlenmesi Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_3",
  }),
  createItem({
    title: {
      en: "Definition: What is a Data Subject?",
      de: "Definition: Was ist eine betroffene Person?",
      tr: "Tanım: İlgili Kişi Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_4",
  }),
  createItem({
    title: {
      en: "Definition: What is a Data Controller?",
      de: "Definition: Was ist ein Verantwortlicher für die Daten?",
      tr: "Tanım: Veri Sorumlusu Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_5",
  }),
  createItem({
    title: {
      en: "Definition: What is a Data Processor?",
      de: "Definition: Was ist ein Datenverarbeiter?",
      tr: "Tanım: Veri İşleyen Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_6",
  }),
  createItem({
    title: {
      en: "Definition: What is an Institution?",
      de: "Definition: Was ist eine Institution?",
      tr: "Tanım: Kurum Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_7",
  }),
  createItem({
    title: {
      en: "Definition: What is a Personal Data Inventory?",
      de: "Definition: Was ist ein personenbezogenes Verzeichnis?",
      tr: "Tanım: Kişisel Veri Envanteri Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_8",
  }),
  createItem({
    title: {
      en: "Definition: What is Verbis?",
      de: "Definition: Was ist Verbis?",
      tr: "Tanım: Verbis Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_9",
  }),
  createItem({
    title: {
      en: "Definition: What is Explicit Consent?",
      de: "Definition: Was ist ausdrückliche Zustimmung?",
      tr: "Tanım: Açık Rıza Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_10",
    keywords: ["onay", "sınır", "özgür"],
  }),
  createItem({
    title: {
      en: "Definition: What is a Data Recording System?",
      de: "Definition: Was ist ein Datenaufzeichnungssystem?",
      tr: "Tanım: Veri Kayıt Sistemi Nedir?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_11",
  }),
  createItem({
    title: {
      en: "Definition: What Does It Mean for Personal Data to Be Public?",
      de: "Definition: Was bedeutet es, wenn personenbezogene Daten öffentlich sind?",
      tr: "Tanım: Kişisel Verilerin Aleni Olması Ne Anlama Geliyor?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_12",
  }),
  createItem({
    title: {
      en: "Definition: What Does It Mean for Personal Data to Be Anonymized?",
      de: "Definition: Was bedeutet es, wenn personenbezogene Daten anonymisiert werden?",
      tr: "Tanım: Kişisel Verilerin Anonim Hale Getirilmesi Ne Anlama Geliyor?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_13",
  }),
  createItem({
    title: {
      en: "Definition: What Does It Mean for Personal Data to Be Deleted?",
      de: "Definition: Was bedeutet es, wenn personenbezogene Daten gelöscht werden?",
      tr: "Tanım: Kişisel Verilerin Silinmesi Ne Anlama Geliyor?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_14",
  }),
  createItem({
    title: {
      en: "Definition: What Does It Mean for Personal Data to Be Destroyed?",
      de: "Definition: Was bedeutet es, wenn personenbezogene Daten zerstört werden?",
      tr: "Tanım: Kişisel Verilerin Yok Edilmesi Ne Anlama Geliyor?",
    },
    location: "/help-center/faqs?cat=cat3&col=col3_15",
  }),
];

// const app = [
//   createItem({
//     title: "Organizasyon Oluşturmak",
//     location: "/help-center/app/organization?col=col1",
//     keywords: ["yeni", "üst", "firma"],
//   }),
//   createItem({
//     title: "Organizasyon Bilgileri",
//     location: "/help-center/app/organization?col=col2",
//     keywords: ["şablon", "kategori", "üç nokta", "detay", "firma"],
//   }),
//   createItem({
//     title: "Organizasyona Kişi Davet Etme",
//     location: "/help-center/app/organization?col=col3",
//     keywords: ["user", "kişi", "ekleme", "oluşturma", "invite", "firma"],
//   }),

//   //Department
//   createItem({
//     title: "Departman Oluşturmak",
//     location: "/help-center/app/department?col=col1",
//     keywords: ["eklemek"],
//   }),
//   createItem({
//     title: "Departman Silmek",
//     location: "/help-center/app/department?col=col2",
//   }),

//   //Process
//   createItem({
//     title: "Faaliyet Oluşturmak",
//     location: "/help-center/app/process?col=col1",
//     keywords: ["eklemek"],
//   }),
//   createItem({
//     title: "Departmana Faaliyet Eklemek",
//     location: "/help-center/app/process?col=col1",
//   }),
//   createItem({
//     title: "Faaliyet Silmek",
//     location: "/help-center/app/process?col=col2",
//   }),

//   //Data Source & Data
//   createItem({
//     title: "Veri Kaynağı Oluşturmak",
//     location: "/help-center/app/datasource?col=col1",
//     keywords: ["eklemek"],
//   }),
//   createItem({
//     title: "Faaliyete Veri Kaynağı Eklemek",
//     location: "/help-center/app/datasource?col=col1",
//   }),
//   createItem({
//     title: "Veri Kaynağı Silmek",
//     location: "/help-center/app/datasource?col=col2",
//   }),

//   createItem({
//     title: "Veri Oluşturmak",
//     location: "/help-center/app/datasource?col=col3",
//     keywords: ["eklemek"],
//   }),
//   createItem({
//     title: "Veri Kaynağına Veri Eklemek",
//     location: "/help-center/app/datasource?col=col3",
//   }),
//   createItem({
//     title: "Veri Minimizasyonu",
//     location: "/help-center/app/datasource?col=col4",
//   }),

//   //Inventory
//   createItem({
//     title: "Envanter Düzenleme",
//     location: "/help-center/app/inventory?col=col1",
//     keywords: ["aktarım", "imha", "saklama", "süre", "toplama", "tedbir", "diğer", "işleme", "inventory", "güncelle"],
//   }),

//   createItem({
//     title: "Envanter Fonsiyonları",
//     location: "/help-center/app/inventory?col=col2",
//     keywords: ["filtre", "filitre", "arama", "sıralama", "drag", "grup", "pin", "reset", "column", "kolon", "sıfırlama"],
//   }),

//   //File
//   createItem({
//     title: "Organizasyon Dosyaları",
//     location: "/help-center/app/file?col=col1",
//     keywords: ["upload", "yükleme", "hukuk", "doküman", "döküman", "form", "açık", "rıza", "aydınlatma", "politika", "sözleşme", "taahhütname"],
//   }),

//   createItem({
//     title: "Organizasyon Sözleşmeleri",
//     location: "/help-center/app/file?col=col2",
//   }),

//   //Question
//   createItem({
//     title: "Organizasyon Soruları",
//     location: "/help-center/app/question?col=col1",
//     keywords: ["not", "firma"],
//   }),

//   //Library
//   createItem({
//     title: "Kullanıcı Kütüphanesi",
//     location: "/help-center/app/library?col=col1",
//     keywords: ["library", "kütüphane", "kişisel", "ekle"],
//   }),

//   //Task
//   createItem({
//     title: "Organizasyon Görevleri",
//     location: "/help-center/app/task?col=col1",
//     keywords: ["task", "özet", "due", "bitiş", "atanan", "rapor"],
//   }),

//   //Announcement
//   createItem({
//     title: "Organizasyon Duyuruları",
//     location: "/help-center/app/announcement?col=col1",
//   }),

//   //Legal Docs
//   createItem({
//     title: "Hukuki Dokümanlar",
//     location: "/help-center/app/legal-document?col=col1",
//     keywords: ["legal", "dok", "döküman", "hukuk", "aydınlatma", "kvkk", "politika", "özel nitelik", "veri", "açık", "rıza", "met", "taahüt", "taslak"],
//   }),

//   //Legal Docs
//   createItem({
//     title: "Yardım / Destek / İletişim",
//     location: "/help-center/support",
//     keywords: ["form", "support", "yardım", "destek", "iletişim", "telefon", "email", "hakkında", "bilgi"],
//   }),
// ];

function createItem({ location, title, keywords = [] }) {
  return {
    keywords: [...Object.keys(title).flatMap((lang) => title[lang].split(" ").map((word) => word.toLowerCase())), ...keywords.map((k) => k.toLowerCase())],
    title,
    location,
  };
}

function filter(terms) {
  return (item) => terms.every((tk) => item.keywords.find((ik) => ik.indexOf(tk) > -1 || tk.startsWith(ik)));
}

export default {
  db: { faq, app },
  search(term, lang = "tr") {
    if (!term || !term.trim()) return {};
    const terms = term
      .toLowerCase()
      .split(" ")
      .filter((i) => !!i);
    return {
      faq: faq.filter(filter(terms, lang)).map((item) => ({ title: item.title[lang], location: item.location, keywords: item.keywords })),
      // app: app.filter(filter(terms, lang)),
    };
  },
};
